export enum Compare {
	Lt = -1,
	Eq = 0,
	Gt = 1,
}

export class InvalidTimestampError extends Error {
	constructor(timestamp: string) {
		super(`Invalid timestamp format: ${timestamp}`);
		this.name = "InvalidTimestampError";
	}
}

export function compareTimestamps(
	timestamp1: string,
	timestamp2: string,
): Compare {
	const t1 = new Date(timestamp1).valueOf();
	const t2 = new Date(timestamp2).valueOf();

	// I might want to return Compare.Eq instead
	if (isNaN(t1)) {
		throw new InvalidTimestampError(timestamp1);
	}
	if (isNaN(t2)) {
		throw new InvalidTimestampError(timestamp2);
	}

	if (t1 < t2) return Compare.Lt;
	if (t1 > t2) return Compare.Gt;
	return Compare.Eq;
}

export const Timestamp = {
	cmp: compareTimestamps,
	greaterThan: (timestamp1: string, timestamp2: string): boolean =>
		compareTimestamps(timestamp1, timestamp2) === Compare.Gt,
	lesserThan: (timestamp1: string, timestamp2: string): boolean =>
		compareTimestamps(timestamp1, timestamp2) === Compare.Lt,
};
